// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rq4T","content":"styles_content__26dGs"};